import { assign } from 'xstate';
import { Context } from '../companiesMachine';

const filterCompanies = assign<Context, any>((ctx, evt) => ({
    ...evt.data,
}));

export default filterCompanies;
